import { render, staticRenderFns } from "./Statictics.vue?vue&type=template&id=fd6b4378&scoped=true&"
import script from "./Statictics.vue?vue&type=script&lang=js&"
export * from "./Statictics.vue?vue&type=script&lang=js&"
import style0 from "./Statictics.vue?vue&type=style&index=0&id=fd6b4378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6b4378",
  null
  
)

export default component.exports